(function () {
	'use strict';

	angular
	.module('core')
	.filter('highlight', highlight);

	highlight.$inject = ['$sce'];

	function highlight($sce){
		return function(text, phrase) {
			if (phrase) text = text.replace(new RegExp('('+phrase.trim()+')', 'gi'), '<span class="highlighted">$1</span>')

			return $sce.trustAsHtml(text)
		}
	}

})();